import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import FormElement from "common/components/FormElement/FormElement";
import Heading from "common/components/Typography/Heading/Heading";
import { checkDayAndHour, getBadHourAndDayMessage } from "common/helpers/HourAndDayChecker";
import React, { useState } from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Axios from 'services/BackendApi/BackendApi';

export default function ForgotForm(props){
    const submitHandler = (e) => {
        let result = null;
        e.preventDefault();
        if (validateData()){
            actionTx();
        }
    }; 
    const [formErrors,setFormErrors] = useState({
        identifier: false,
        email:false
    });
    const [formData, setFormData] = useState({
        identifier: '',
        email: ''
    });
    const [txData,setTxData] = useState({
        loading:false,
        finalized: false,
        result: false,
        messages: []
    })
    function onchangeInput(evc){
        let newErrors = {...formErrors};
        switch (evc.target.name){
            case "formIdentifier":{
                setFormData({...formData,identifier:evc.target.value});
                newErrors.identifier = false;
            }break;
            case "formEmail":{
                setFormData({...formData,email:evc.target.value});
                newErrors.email = false;
            }break;
        }
        setFormErrors(newErrors);
    }
    function validateData(){
        let newErrors = {...formErrors};
        newErrors.identifier=(formData.identifier.trim()==="");
        newErrors.email = (formData.email.trim()==="");
        setFormErrors(newErrors);
        return !newErrors.identifier && !newErrors.email;
    }
    async function actionTx(){
        if (!txData.loading){
            setTxData({...txData,loading:true});
            const {data} = await Axios.ProveedorForgot(formData);
            console.log('Result Forgot',data);
            if (data.error && data.error===true){
                setFormErrors({...formErrors,__form_general_error:data.error_log[0],response_error_log:data.error_log});
                setTxData({loading:false,result:false,finalized:true});
            }else{
                setTxData({loading:false,result:true,finalized: true, messages: data.msg });
            }
        }
    }
    if (txData.finalized===true){
        return <div>
                <Heading variant="h2">{
                    (txData.result===true)? "Éxito":"Hubo un error"
                }</Heading>
                <div>
                    {(txData.result===true)? <div>
                        <CheckMarkSuccess />
                        <div>
                            {txData.messages}
                        </div>
                    </div>:
                    <div>
                        <ErrorMark />
                        <div>
                           
                            {
                                (formErrors.response_error_log)?
                                    
                                    formErrors.response_error_log.map((emsg,idx)=>{
                                        return <Heading variant='h4' key={idx}>{emsg}</Heading>
                                    }):'No se pudo completar la operación, por favor vuelva a solicitar un cambio de contraseña.'
                                    
                            }
                        </div>
                    </div>}
                </div>
                <div>
                    <Link to="/user/login">Regresar</Link>
                </div>
        </div>;
    }
    if (checkDayAndHour()===true)
    return <div>
        <Heading variant="h1">Reestablecer la contraseña</Heading>
                    <Form onSubmit={submitHandler}>

                    <FormElement 
                          margin="1" 
                          id="formIdentifier" 
                          label="Identificador" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="formIdentifier" 
                          error={formErrors.identifier}     
                          errorMessage="Por favor ingrese un identificador"                     
                          placeholder="Número de proveedor o NIT"
                    />
                    <FormElement 
                          margin="1" 
                          id="formEmail" 
                          label="E-mail" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="formEmail" 
                          error={formErrors.email}     
                          errorMessage="Por favor ingrese email válido"                     
                          placeholder="Ingrese e-mail resgistrado"
                    />
                    <Button variant="primary" type="submit">
                        Solicitar cambio de contraseña 
                    </Button>
                    </Form>
    </div>;
    else
      return  getBadHourAndDayMessage();
}